import axios from "~/plugins/axios";

export default {
  get(name, type = "user") {
    return axios.get(`/web_api/v1/key_value_store/get/${type}/${name}`)
      .then((response) => response.data);
  },
  has(name, type = "user") {
    return axios.get(`/web_api/v1/key_value_store/has/${type}/${name}`)
      .then((response) => response.data);
  },
  set(name, value, type = "user") {
    return axios.post(`/web_api/v1/key_value_store/set/${type}`, {
      name, value,
    }).then((response) => response.data);
  },
  forget(name, type = "user") {
    return axios.delete(`/web_api/v1/key_value_store/forget/${type}/${name}`)
      .then((response) => response.data);
  },
  getIfHas(name, type = "user") {
    return this.has(name, type).then((has) => {
      if (has) {
        return this.get(name, type);
      }
      return null;
    });
  },
};
